<script>
import baseMixin from '@/mixins/baseMixin'
import formMixin from '@/mixins/formMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'BookingPendingApprovalsRejectBookingDialog',
  mixins: [baseMixin, formMixin],
  model: {
    prop: 'show',
    event: 'showUpdated',
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data: () => {
    return {
      reasonForRejection: '',
    }
  },
  computed: {
    ...mapGetters({
      isLoadingSubmitPendingApproval:
        'bookingApprovals/isLoadingSubmitPendingApproval',
    }),
    compInputLabel() {
      return this.isMobileViewPort
        ? this.$t('booking.details.approvals.submit.rejectReasonMobileLabel')
        : this.$t('booking.details.approvals.submit.rejectReasonLabel')
    },
    isSubmitButtonDisabled() {
      return this.reasonForRejection.trim() === ''
    },
  },
  methods: {
    closeDialog() {
      this.$emit('showUpdated', false)
    },
    rejectBookingAndClose() {
      this.$emit('rejectRequest', this.reasonForRejection)
      this.$emit('showUpdated', false)
    },
  },
}
</script>

<template>
  <v-dialog
    :value="show"
    max-width="600"
    :persistent="isLoadingSubmitPendingApproval"
    @input="closeDialog"
  >
    <v-card id="reject-booking-dialog">
      <v-card-title>
        {{ $t('booking.details.approvals.submit.rejectReasonDialogTitle') }}
      </v-card-title>
      <v-card-text>
        <v-textarea
          v-model="reasonForRejection"
          data-testid="reject-booking-dialog__reason-textarea"
          :label="compInputLabel"
          required
          auto-grow
          autofocus
          :rules="[rules.required]"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="isLoadingSubmitPendingApproval"
          @click="closeDialog"
        >
          {{ $t('general.close') }}
        </v-btn>
        <v-btn
          data-testid="reject-booking-dialog__submit-btn"
          :disabled="isSubmitButtonDisabled"
          color="red"
          text
          :loading="isLoadingSubmitPendingApproval"
          @click="rejectBookingAndClose"
        >
          {{ $t('booking.details.actions.rejectBookingBtn') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
